const BASE_URL = '/lishui-gov'
const BASE = '/dev-api'
import request from '@/common/api/request'
// 企业商品列表 分页查询
export const listByPage = params => request(BASE_URL + '/govGoods/govPage', { params })
// 数量统计
export const statusCount = params => request(BASE_URL + '/govGoods/govCount', { params })
// 商品详情
export const productDetail = params => request(BASE_URL + '/govGoods/govDetail', { params })

// 审核商品
export const auditProduct = params => request.post(BASE_URL + '/govGoods/auditGoods', params)

// 批量下架商品 /lishui-gov/entGoods/offGoods
export const offGoods = data =>
  request.post(BASE_URL + '/govGoods/offGoods', data)
// 商品導出 /lishui-gov/entGoods/downloadGoods
export const downloadGoods = params =>
  request.downLoad(BASE_URL + '/govGoods/downloadGoods', params)
